import React from "react";
import { useDialog } from "contexts";

import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { StyledButton, StyledDialog } from "customStyled";
import { isValidValue } from "utils";
import { useTranslation } from "react-i18next";

const ErrorDialog = () => {
  const { t } = useTranslation();
  const { error, hideError } = useDialog();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));
  const handleClose = () => {
    if (isValidValue(error?.close)) {
      error.close();
    }
    hideError();
  };
  return (
    <React.Fragment>
      <StyledDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullScreen={fullScreen}
        open={isValidValue(error)}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {t("error")}
        </DialogTitle>
        <DialogContent sx={{ width: 400 }} dividers>
          <Typography sx={{ textAlign: "center" }} gutterBottom>
            {error?.message}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <StyledButton variant="contained" color="error" onClick={handleClose}>
            {t("ok")}
          </StyledButton>
        </DialogActions>
      </StyledDialog>
    </React.Fragment>
  );
};

export default ErrorDialog;
